var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTamperingNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12422_187717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.428 12.1013L21.9727 11.4844M18.672 16.9504L19.2889 18.495M15.715 17.1181L15.0192 18.7393M20.3089 14.7816L21.9301 15.4774",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31776 9.47723L3.17753 15.6466C3.01482 15.8082 2.88568 16.0004 2.79755 16.2122C2.70943 16.4239 2.66406 16.651 2.66406 16.8804C2.66406 17.1097 2.70943 17.3368 2.79755 17.5485C2.88568 17.7603 3.01482 17.9525 3.17753 18.1141C3.50635 18.4412 3.95128 18.6248 4.41506 18.6248C4.87884 18.6248 5.32377 18.4412 5.65259 18.1141L11.8128 11.9722M14.8958 13.8792L17.0465 11.7285C17.2025 11.5726 17.29 11.3611 17.29 11.1406C17.29 10.92 17.2025 10.7085 17.0465 10.5526L10.7375 4.2435C10.5815 4.08759 10.37 4 10.1495 4C9.92896 4 9.71746 4.08759 9.56149 4.2435L7.41079 6.3942C7.25488 6.55017 7.16729 6.76167 7.16729 6.9822C7.16729 7.20273 7.25488 7.41423 7.41079 7.57019L13.7199 13.8792C13.8758 14.0352 14.0873 14.1227 14.3078 14.1227C14.5284 14.1227 14.7399 14.0352 14.8958 13.8792Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12422_187717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTamperingNotification);
export default __webpack_public_path__ + "static/media/Tampering-notification.e4a47786924a7de3daab0f9570f788a4.svg";
export { ForwardRef as ReactComponent };